<template>
    <v-card class="pa-3" v-if="permission || superUser" :value="$route.path">
        <v-row class="d-flex justify-center">
            <v-col cols="12" md="12" sm="12">
                <v-card elevation="0">
                    <BillingsTable :billings="billings" :pagination="pagination"/>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import BillingsTable from "@/components/general/settings/billingDashboard/BillingsTable.vue";
import translations from "@/utils/translations/general/settings/billingDashboard";

export default {
    name: "BillingDashboardPaymentHistory",

    components: { BillingsTable },

    mixins: [translations],

    computed: {
        ...mapState(["superUser"]),

        ...mapState(
            "general/settings/billingDashboard/paymentHistory",
            ["billings", "pagination"]
        ),

        lang() {
            return this.$route.params.lang;
        },

        permission() {
            return (
                this.superUser ||
                (this.$store.state.permissions.general_settings
                    ? this.$store.state.permissions.general_settings.billing_dashboard.read
                    : null)
            );
        },
    },
    methods: {
        ...mapActions("general/settings/billingDashboard/paymentHistory", [
            "getPaymentHistory",
        ]),

      
    },

    watch: {
        permission: {
            handler(val) {
                if (!val && !this.superUser) {
                    this.$router.replace(
                        `/${this.lang}/storePanel/forbidden-gateway`
                    );
                }
            }
        },

    ["pagination.current_page"]: {
        handler(val) {
            this.getPaymentHistory(`?page=${val}`)
        },
        immediate: true,
    },
},
    
};
</script>
